export enum ReportCustomizationRunConfigurationNamesEnum {
  LatestPublished = "Latest Published",
  Unpublished = "Unpublished",
  Projected = "Projected",
  Termed = "Termed",
  ProjectedTermed = "Projected-Termed",
}
